import { FormControl as MuiFormControl, styled } from "@mui/material";

export const FormControl = styled(MuiFormControl)`
  max-width: 18rem;
  min-width: 18rem;
`;
